export default __webpack_public_path__ + "static/climate-environmental-justice-accomplishment-5-3915a99a85ff95ef73186e8af937ed3c.webp";